import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/services/document.service';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-moderator-view-document',
  templateUrl: './moderator-view-document.component.html',
  styleUrls: ['./moderator-view-document.component.scss'],
})
export class ModeratorViewDocumentComponent implements OnInit {
  public QuillConfiguration = {};
  public document: any = {};
  public title: any;
  public keywords: any;
  public summary: any;
  public showcase: any;
  public country: any;
  public city: any;
  public zipCode: any;
  public cityPopulation: any;
  public durationFrom: any;
  public durationTo: any;
  public type: any;
  public overview: any;
  public multiObjective: any;
  public implementations: any;
  public others: any;
  public references: any;
  public editorContent: any;
  public id: any;

  constructor(
    private doc: DocumentService,
    private req: HttpRequestsService<any>,
    private router: Router
  ) {}

  ngOnInit() {
    this.document = this.doc.data;
    this.id = this.document.id;
    this.title = this.document.title;
    this.keywords = this.document.keywords;
    this.summary = this.document.summary;
    this.showcase = this.document.showcase;
    this.country = this.document.country;
    this.city = this.document.city;
    this.zipCode = this.document.zipCode;
    this.cityPopulation = this.document.cityPopulation;
    this.durationFrom = this.document.yearFrom;
    this.durationTo = this.document.yearTo;
    this.type = this.document.type;
    this.overview = this.document.overview;
    this.multiObjective = this.document.multiObjectiveApproachSections;
    this.implementations = this.document.implementationActivitySections;
    this.others = this.document.otherSections;
    this.references = this.document.references;
  }

  onEditorCreated(event) {
    const selection = event.getSelection(true);
    event.root.innerHTML(selection.index, this.summary);
  }

  publish() {
    this.req.publishDocument(this.id, {}).subscribe()
    Swal.fire(
      'Done!',
      'Document published!',
      'success'
    )
      setTimeout( () => {
        this.router.navigate(['Moderator']);
      },1000)
    
  }

  unpublish() {
    this.req.rejectDocument(this.id, {}).subscribe()
    Swal.fire(
      'Done!',
      'Document rejected!',
      'error'
    )
    setTimeout( () => {
      this.router.navigate(['Moderator']);
    },1000)
    
  }
}
